import { Component } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { RiveDirective } from '@examdojo/ui/rive';
import { IonFooter, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { CLASS_LIMIT_REACHED_DIALOG_ID } from './class-limit-reached-dialog.service';

@Component({
  selector: 'dojo-class-limit-reached-dialog',
  template: `
    <ion-header [translucent]="true" class="!border-b-0">
      <ion-toolbar class="!px-2 md:!px-4">
        <div slot="start" class="flex w-8"></div>
        <ion-title class="common-ion-title !px-2">
          {{ 'classes.class_limit_reached_dialog.title' | transloco }}
        </ion-title>
        <div slot="end" class="flex">
          <dojo-icon-button (click)="dismiss()" [icon]="'xmark'" />
        </div>
      </ion-toolbar>
    </ion-header>

    <div class="flex flex-col items-center gap-4 px-4 py-2 md:px-6">
      <canvas
        #riveCanvas
        rive
        class="mx-auto w-[120px] max-w-full"
        [riveFile]="'assets/images/sensei/shocked.riv'"
        [artboard]="'Shocked'"
        [stateMachine]="'State Machine 1'"
        [autoplay]="true"
        width="600"
        height="600"
      ></canvas>

      <span class="text-secondary text-md text-center">
        {{ 'classes.class_limit_reached_dialog.message' | transloco }}
      </span>
    </div>

    <ion-footer class="shadow-none">
      <div class="flex justify-center p-4 md:p-6">
        <dojo-button [customColor]="'sky'" (click)="dismiss()">
          {{ 'classes.class_limit_reached_dialog.confirm' | transloco }}
        </dojo-button>
      </div>
    </ion-footer>
  `,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    ButtonComponent,
    IconButtonComponent,
    RiveDirective,
    TranslocoPipe,
  ],
})
export class ClassLimitReachedDialogComponent {
  constructor(private readonly modalController: ModalController) {}

  dismiss() {
    this.modalController.dismiss(false, undefined, CLASS_LIMIT_REACHED_DIALOG_ID);
  }
}
